import Datetime from 'react-datetime'
import moment from 'moment'
import type { InstallationPilingSiteOption, InstallationPilingSiteState } from '../../types'
import { wonFormCheckInput, wonFormCheckLabel, wonFormCheckRow } from '../../formCheckClasses'

interface Props {
  isView: boolean
  pilingSite: InstallationPilingSiteState
  updatePilingSite: (patch: Partial<InstallationPilingSiteState>) => void
}

const PILING_SITE_OPTIONS: { value: InstallationPilingSiteOption; label: string }[] = [
  { value: 'factory', label: 'เช็คโรงงานมีเสาเข็ม' },
  { value: 'maturity', label: 'เสาเข็มได้อายุวันที่' },
  { value: 'completed', label: 'เรียบร้อย' },
  { value: 'not_completed', label: 'ยังไม่เรียบร้อย' },
]

const InstallationPilingSiteSection: React.FC<Props> = ({
  isView,
  pilingSite,
  updatePilingSite,
}) => {
  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>สถานที่ตอกเสาเข็ม</div>
        </div>
        <div className='card-body'>
          <div className='d-flex flex-column gap-4'>
            {PILING_SITE_OPTIONS.map(opt => (
              <div key={opt.value} className='d-flex flex-wrap align-items-center gap-3'>
                <div className={wonFormCheckRow}>
                  <input
                    className={wonFormCheckInput}
                    type='radio'
                    name='won-install-piling-site-option'
                    id={`won-install-piling-site-${opt.value}`}
                    checked={pilingSite.option === opt.value}
                    disabled={isView}
                    onChange={() => updatePilingSite({ option: opt.value })}
                  />
                  <label className={wonFormCheckLabel} htmlFor={`won-install-piling-site-${opt.value}`}>
                    {opt.label}
                  </label>
                </div>
                {opt.value === 'maturity' && (
                  <Datetime
                    locale='en'
                    dateFormat='DD/MM/YYYY'
                    timeFormat={false}
                    value={pilingSite.maturityDate ?? undefined}
                    onChange={(val: any) => {
                      if (moment.isMoment(val) || val instanceof Date) {
                        updatePilingSite({
                          maturityDate: moment(val).toDate(),
                          option: 'maturity',
                        })
                      }
                    }}
                    renderInput={props => (
                      <input
                        {...props}
                        autoComplete='off'
                        className='form-control form-control-sm'
                        style={{ maxWidth: 160 }}
                        disabled={isView || pilingSite.option !== 'maturity'}
                      />
                    )}
                    closeOnClickOutside
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default InstallationPilingSiteSection
